import ForgetPassword from "../components/user/ForgotPassword";

function ForgotPassword() {
  return (
    <div className="page p-1">
      <ForgetPassword />
    </div>
  );
}

export default ForgotPassword;
